var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagination" },
    [
      _c("van-pagination", {
        attrs: {
          "force-ellipses": _vm.total > 24 ? true : false,
          "items-per-page": 8,
          "next-text": "Next",
          "prev-text": "Previous",
          "show-page-size": _vm.pagesize,
          "total-items": _vm.total
        },
        on: { change: _vm.pageChange },
        model: {
          value: _vm.cur,
          callback: function($$v) {
            _vm.cur = $$v
          },
          expression: "cur"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8926acda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8926acda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/pagination.vue
// module id = null
// module chunks = 